import React from "react";
import "./Requirements.css";
import { useTranslation } from "react-i18next";
const NationxRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      {t("carriers.custom.requirements.nationx")}
    </div>
  );
};

export default NationxRequirements;
